export const MALL_REPORT_SHARE_PATH = '/share/mallreport';

interface MallReportShareRedirectOptions {
  pathname: string;
  search?: string;
  hash?: string;
  shouldRedirect: boolean;
  targetBaseUrl?: string;
  currentOrigin: string;
}

const normalizeBaseUrl = (url: string) => url.trim().replace(/\/+$/, '');

export const getMallReportShareRedirectUrl = ({
  pathname,
  search = '',
  hash = '',
  shouldRedirect,
  targetBaseUrl,
  currentOrigin,
}: MallReportShareRedirectOptions) => {
  if (pathname !== MALL_REPORT_SHARE_PATH || !shouldRedirect || !targetBaseUrl) {
    return null;
  }

  const normalizedTargetBaseUrl = normalizeBaseUrl(targetBaseUrl);
  if (!normalizedTargetBaseUrl || normalizedTargetBaseUrl === normalizeBaseUrl(currentOrigin)) {
    return null;
  }

  return `${normalizedTargetBaseUrl}${MALL_REPORT_SHARE_PATH}${search}${hash}`;
};
